export function countTrueFalse(dataObj) {
  const trueCount = dataObj.filter((item) => item.status).length;
  const falseCount = dataObj.length - trueCount;
  return { trueCount: trueCount, falseCount: falseCount };
}
